let prefetched = false;

export function prefetchVirtualSpace() {
  if (prefetched) return;
  prefetched = true;
  void import('../../pages/VirtualSpacePage');
}
